import { render, staticRenderFns } from "./Navbar.Extra.vue?vue&type=template&id=4dc7a965&"
import script from "./Navbar.Extra.vue?vue&type=script&lang=js&"
export * from "./Navbar.Extra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports